namespace TabAurous.Production {
    export interface TreeMakingRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        ProcessId?: number;
        DepartmentId?: number;
        RMDepartmentId?: number;
        TermsId?: number;
        CurrencyId?: number;
        TreeNo?: string;
        KaratId?: number;
        MetalColorId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Purity?: number;
        Remark?: string;
        CompanyId?: number;
        EmployeeId?: number;
        AddressId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        FinancialYearId?: number;
        UserId?: number;
        Username?: string;
        TreeWeight?: number;
        BaseWeight?: number;
        ConversionFactor?: number;
        ButtonWeight?: number;
        MetalRequired?: number;
        MetalIssued?: number;
        MetalConsumed?: number;
        MetalBalance?: number;
        Loss?: number;
        LossPercent?: number;
        ItemDetails?: TreeMakingItemsRow[];
        IssueDetails?: TreeMakingIssueRow[];
        ReceiptDetail?: TreeMakingReceiptRow[];
    }

    export namespace TreeMakingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.TreeMaking';
        export const deletePermission = 'Production:TreeMaking:Delete';
        export const insertPermission = 'Production:TreeMaking:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:TreeMaking:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            ProcessId = "ProcessId",
            DepartmentId = "DepartmentId",
            RMDepartmentId = "RMDepartmentId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            TreeNo = "TreeNo",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            Purity = "Purity",
            Remark = "Remark",
            CompanyId = "CompanyId",
            EmployeeId = "EmployeeId",
            AddressId = "AddressId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            Username = "Username",
            TreeWeight = "TreeWeight",
            BaseWeight = "BaseWeight",
            ConversionFactor = "ConversionFactor",
            ButtonWeight = "ButtonWeight",
            MetalRequired = "MetalRequired",
            MetalIssued = "MetalIssued",
            MetalConsumed = "MetalConsumed",
            MetalBalance = "MetalBalance",
            Loss = "Loss",
            LossPercent = "LossPercent",
            ItemDetails = "ItemDetails",
            IssueDetails = "IssueDetails",
            ReceiptDetail = "ReceiptDetail"
        }
    }
}
